module.exports = __webpack_public_path__ + "img/third_zhCn.c4f3a6cc.png";